export var EDITOR_CREATE_IMAGE_GALLERY = 'EDITOR_CREATE_IMAGE_GALLERY';
export var EDITOR_PERFORMANCE = 'EDITOR_PERFORMANCE';
export var EDITOR_BLOCK_ACTION_FORMAT = 'EDITOR_BLOCK_ACTION_FORMAT';
export var EDITOR_TOOLBAR_ACTION = 'EDITOR_TOOLBAR_ACTION';
export var EDITOR_OPEN_SLASH_COMMAND = 'EDITOR_OPEN_SLASH_COMMAND';
export var EDITOR_PASTE_PERFORMANCE = 'EDITOR_PASTE_PERFORMANCE';
export var DATABASE_CHANGE_COLUMN_TYPE = 'DATABASE_CHANGE_COLUMN_TYPE';
export var DATABASE_ADD_ROW = 'DATABASE_ADD_ROW';
export var DATABASE_ADD_COLUMN = 'DATABASE_ADD_COLUMN';
export var DATABASE_EDIT_COLUMN_NAME = 'DATABASE_EDIT_COLUMN_NAME';
export var DATABASE_EDIT_CELL = 'DATABASE_EDIT_CELL';
export var DATABASE_SORT = 'DATABASE_SORT';
export var DATABASE_ADD_TAG = 'DATABASE_ADD_TAG';
export var DATABASE_EDIT_TAG_COLOR = 'DATABASE_EDIT_TAG_COLOR';